export const SNYK_DISCOVERY_REQ = 'SNYK_DISCOVERY_REQ'
export const SNYK_DISCOVERY_SUCCESS = 'SNYK_DISCOVERY_SUCCESS'
export const SNYK_DISCOVERY_ERROR = 'SNYK_DISCOVERY_ERROR'
export const SNYK_DISCOVERY_RESET_STATUS = 'SNYK_DISCOVERY_RESET_STATUS'



// WEBPACK FOOTER //
// ./src/store/modules/agents/snyk-discovery.type.js